import { useMemo, useState } from 'react';

const normalize = value => String(value || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase();

const displayName = user => {
    const parts = [user.nom, user['primer-cognom'], user['segon-cognom']]
        .filter(Boolean)
        .join(' ');

    return parts || user.mote || `Casteller #${user.id}`;
};

function DeletedCastellersTab({ deletedUsers, onRestore }) {
    const [search, setSearch] = useState('');
    const [restoringId, setRestoringId] = useState(null);

    const filteredUsers = useMemo(() => {
        const query = normalize(search);

        return (deletedUsers || [])
            .filter(user => {
                if (!query) return true;
                return normalize(`${user.nom} ${user['primer-cognom']} ${user['segon-cognom']} ${user.mote}`).includes(query);
            })
            .sort((a, b) => {
                const aDate = new Date(a.deleted_at || 0).getTime();
                const bDate = new Date(b.deleted_at || 0).getTime();
                return bDate - aDate;
            });
    }, [deletedUsers, search]);

    const handleRestore = async user => {
        const shouldRestore = window.confirm(`Vols restaurar ${displayName(user)}?`);
        if (!shouldRestore) return;

        setRestoringId(user.id);
        try {
            await onRestore(user);
        } finally {
            setRestoringId(null);
        }
    };

    return (
        <div className="deleted-castellers-tab">
            <div className="filters-container deleted-castellers-toolbar">
                <div className="filters-basic-row">
                    <input
                        className="search-input"
                        placeholder="Busca a la paperera..."
                        type="text"
                        value={search}
                        onChange={event => setSearch(event.target.value)}
                    />
                </div>
                <div className="filter-results-row">
                    <span className="results-count">
                        {filteredUsers.length} de {(deletedUsers || []).length} castellers eliminats
                    </span>
                </div>
            </div>

            <div className="deleted-castellers-table-container">
                <table className="deleted-castellers-table">
                    <thead>
                        <tr>
                            <th>Sobrenom</th>
                            <th>Nom</th>
                            <th>1r Cognom</th>
                            <th>2n Cognom</th>
                            <th>Eliminat</th>
                            <th>Accions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {filteredUsers.map(user => (
                            <tr key={user.id}>
                                <td>{user.mote || '-'}</td>
                                <td>{user.nom || '-'}</td>
                                <td>{user['primer-cognom'] || '-'}</td>
                                <td>{user['segon-cognom'] || '-'}</td>
                                <td>{user.deleted_at ? new Date(user.deleted_at).toLocaleString() : '-'}</td>
                                <td>
                                    <button
                                        className="restore-casteller-button"
                                        onClick={() => handleRestore(user)}
                                        disabled={restoringId === user.id}
                                    >
                                        <i className="fas fa-undo"></i>
                                        <span>{restoringId === user.id ? 'Restaurant...' : 'Restaurar'}</span>
                                    </button>
                                </td>
                            </tr>
                        ))}
                        {filteredUsers.length === 0 ? (
                            <tr>
                                <td colSpan="6" className="deleted-castellers-empty">
                                    No hi ha castellers eliminats amb aquest filtre.
                                </td>
                            </tr>
                        ) : null}
                    </tbody>
                </table>
            </div>
        </div>
    );
}

export default DeletedCastellersTab;
